import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // BLINDAJE: Manejo inteligente de estados controlados y no controlados.
    // Si 'value' es undefined o null, usamos una cadena vacía para evitar el error de NextJS/React.
    const isControlled = 'value' in props;
    const value = isControlled ? (props.value ?? "") : undefined;

    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
        {...(isControlled ? { value } : {})}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
